<template>
  <van-popup v-model="show" class="popup" round position="bottom">
    <div class="title">{{ current.title }}</div>
    <div v-if="current.important" class="important">
      {{ current.important }}
    </div>
    <div class="info">1.手机亮屏显示IMEI清晰照（拨号键输入*#06#）。<br />
      2.手机正面黑屏照。<br />
      3.手机背面照。<br />
      注：每张照片需露出手机四角。
      </div>
    <img :src="current.image" />
  </van-popup>
</template>
<script>
import Vue from "vue";
import { Popup } from "vant";

Vue.use(Popup);

const list = [
  {
    type: 0,
    title: "被保障手机正面IMEI码照",
    important: "（需要设置调出IMEI码）",
    image: require("../assets/hint_phone_imei.png"),
  },
  {
    type: 1,
    title: "被保障手机正面息屏照",
    image: require("../assets/hint_phone_close_screen.png"),
  },
  {
    type: 2,
    title: "被保障手机背面照",
    image: require("../assets/hint_phone_back.png"),
  },
];

export default {
  name: "TakingHintDialog",
  data() {
    return {
      show: false,
      list: list,
    };
  },
  props: ["value", "type"],
  computed: {
    current() {
      return this.list[this.type];
    },
  },
  created() {
    this.show = this.value;
  },
  watch: {
    show(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.show = val;
    },
  },
};
</script>

<style lang="less" scoped>
.popup{
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title{
  font-size: 18px;
  font-weight: 600;
  color: #000;
}
.important{
  font-size: 16px;
  font-weight: 500;
  color:#D35050;
}
.info{
  font-size: 13px;
  color: #333;
  margin-top: 20px;
}
img{
  width: 148px;
  margin-top: 16px;
}
</style>
